<template>
  <div>
    <!-- REGISTRO SOLICITUDES-->
    <!--<v-card class="mx-auto my-5">-->
    <v-card class="mx-auto">
      <v-system-bar color="#1973a5" dark>
        <v-flex class="m-4">
          <center>REGISTRO DE ASIGNACIÓN DE CUPOS</center>
        </v-flex>
      </v-system-bar>
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-row class="mt-4 container">
          <v-col cols="12" sm="12" md="12">
            <v-autocomplete v-model="editedItem.paciente" :items="itemsDatosPaciente" item-text="paciente"
              item-value="id" id="inputField" dense label="PACIENTE NOMBRE"></v-autocomplete>
          </v-col>
          <v-col cols="12" sm="12" md="12">
            <v-autocomplete v-model="editedItem.paciente" :items="itemsDatosPaciente" item-text="num_doc"
              item-value="id" id="inputDNI" dense label="DNI"></v-autocomplete>
          </v-col>
          <v-col cols="12" sm="12" md="12">
            <v-btn color="blue darken-1" text @click="openReporte"> Ver Disponibilidad </v-btn>
          </v-col>
          <v-col cols="12" sm="12" md="12">
            <v-text-field v-model="editedItem.clinica" item-text="descripCas" item-value="url" :rules="[rules.required]"
              dense label="Clínica" disabled></v-text-field>
          </v-col>
          <v-col cols="6" sm="6" md="6">
            <v-text-field v-model="editedItem.turno" :rules="[rules.required]" dense label="Turno"
              disabled></v-text-field>
          </v-col>
          <v-col cols="6" sm="6" md="6">
            <v-text-field v-model="editedItem.frecuencia" :rules="[rules.required]" dense label="Frecuencia"
              disabled></v-text-field>
          </v-col>
          <v-col cols="6" sm="6" md="6">
            <v-text-field v-model="editedItem.tipoPuesto" :rules="[rules.required]" dense label="Serología"
              disabled></v-text-field>
          </v-col>
          <v-col cols="6" sm="6" md="6">
            <v-select v-model="editedItem.numeroPuesto" :rules="[rules.required]" :items="itemsNumeroPuesto" dense
              label="Número Puesto"></v-select>
          </v-col>
        </v-row>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="close"> Cancelar </v-btn>
          <v-btn color="blue darken-1" text @click="save"> Aceptar </v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
    <v-dialog v-model="dialogLoad" hide-overlay persistent width="300" class="fondo-griss">
      <v-card color="primary" dark>
        <v-card-text>
          Cargando Datos
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-if="dialogReporte" v-model="dialogReporte" hide-overlay persistent width="1000" class="fondo-griss">
      <ListaClinicaCupos @editClose="editClose" @itemArray="itemArray" :pacienteData="pacienteDataLista" />
    </v-dialog>
  </div>
</template>
<style>
.v-dialog__content--active {
  background: #59595940;
  backdrop-filter: blur(1px);
}

.v-system-bar.theme--dark {
  padding: 1rem;
  color: white;
}
</style>
<script>
export const USUARIO = process.env.VUE_APP_USERNAME;
export const PASSWORD = process.env.VUE_APP_PASSWORD;
export const RUTA_API = process.env.VUE_APP_API;
import axios from "axios";
import Swal from "sweetalert2";
import ListaClinicaCupos from "./lista_clinica_cupos.vue"

export default {
  props: ["pacienteData"],
  data: () => ({
    dialogReporte: false,
    itemsClinicaFinal: null,
    dialogLoad: false,
    editedItem: {
      //Cupos
      paciente: "",
      frecuencia: "",
      turno: "",
      nombrePaciente: "",
      correo: "",
    },
    headers: [],
    desserts: [],
    dialog: false,
    valid: true,
    rules: {
      required: (value) => !!value || "Campo Obligatorio.",
      email: (value) => !!/\w+@\w+\.+[a-z]/.test(value) || "Correo invalido",
    },
    itemsDatosPaciente: [],
    itemsNumeroPuesto: [],
    itemsClinicas: [],
    dominioAsisCuposPac: null
  }),
  methods: {
    itemArray(item) {
      this.dialogReporte = false;
      this.editedItem.clinica = item.clinica;
      this.editedItem.turno = item.turno;
      this.editedItem.frecuencia = item.frecuencia;
      this.editedItem.tipoPuesto = item.tipoPuesto;
      this.buscarCuposClinica(item.cas_id);
      this.updateClinica(item.cas_id);
      console.log("item de padre", item);
    },
    editClose() {
      this.dialogReporte = false;
    },
    openReporte() {
      this.dialogReporte = true;
    },
    updateClinica(item) {
      axios
        .post(RUTA_API + "/api/token/", {
          username: USUARIO,
          password: PASSWORD,
        })
        .then((response) => {
          this.auth = "Bearer " + response.data.access;
          axios
            .get(
              RUTA_API + "/asigCuposPacIndex/?cas_id=" + item + "&nombres=&num_doc=",
              {
                headers: { Authorization: this.auth },
              }
            )
            .then((res) => {
              var tercerSlashIndex = res.data[0].url.indexOf('/', res.data[0].url.indexOf('/') + 2); // Encuentra la posición del tercer '/'
              var parteExtraida = res.data[0].url.substring(0, tercerSlashIndex);
              this.dominioAsisCuposPac = parteExtraida;
              console.log("loc", parteExtraida);
            })
            .catch((res) => {
              console.warn("Error:", res);
              this.dialog = false;
            });
        })
        .catch((response) => {
          response === 404
            ? console.warn("lo sientimos no tenemos servicios")
            : console.warn("Error:", response);
        });
    },
    buscarCuposClinica(item) {
      this.dialogLoad = true;
      axios
        .post(RUTA_API + "/api/token/", {
          username: USUARIO,
          password: PASSWORD,
        })
        .then((response) => {
          this.auth = "Bearer " + response.data.access;
          axios
            .post(
              RUTA_API +
              "/generar_lista_disponible/", { clinica_id: item },
              {
                headers: { Authorization: this.auth },
              }
            )
            .then((res) => {
              this.dialogLoad = false;
              this.desserts = res.data;
              for (let i = 0; i < this.desserts.length; i++) {
                /* const element = this.desserts[i]; */
              };
              this.updateNumPuesto();
            })
            .catch((res) => {
              console.log("SSSSS", res.data);
            });
        });
    },
    updateNumPuesto() {
      this.itemsNumeroPuesto = [];
      const numeroPuesto = this.desserts.filter(
        (e) =>
          e.turno == this.editedItem.turno &&
          e.frecuencia == this.editedItem.frecuencia &&
          e.tipoPuesto == this.editedItem.tipoPuesto)
        .sort((a, b) => a.numeroPuesto - b.numeroPuesto);
      for (let i = 0; i < numeroPuesto.length; i++) {
        const element = numeroPuesto[i];
        this.itemsNumeroPuesto.push(element.numeroPuesto);
      };
    },
    clinicaFinal() {
      this.itemsClinicaFinal = this.desserts.filter(
        (e) =>
          e.turno == this.editedItem.turno &&
          e.frecuencia == this.editedItem.frecuencia &&
          e.tipoPuesto == this.editedItem.tipoPuesto &&
          e.numeroPuesto == this.editedItem.numeroPuesto
      );
    },
    listarPacientes() {
      console.log("pacienteData", this.pacienteData);
      this.dialogLoad = true;
      axios
        .post(RUTA_API + "/api/token/", {
          username: USUARIO,
          password: PASSWORD,
        })
        .then((response) => {
          this.auth = "Bearer " + response.data.access;
          axios
            .post(
              RUTA_API + "/generar_lista_pacientes_nuevos/", {},
              {
                headers: { Authorization: this.auth },
              },
            )
            .then((res) => {

              this.itemsDatosPaciente = res.data;
              this.dialogLoad = false;

              this.dialogDataApi = false;
            })
            .catch((res) => {
              console.warn("Error:", res);

              this.dialogLoad = false;
            });
        })
        .catch((response) => {
          this.dialogLoad = false;
          response === 404
            ? console.warn("lo sientimos no tenemos servicios")
            : console.warn("Error:", response);
        });
    },
    clinicasInit() {
      this.dialogLoad = true;
      axios
        .post(RUTA_API + "/api/token/", {
          username: USUARIO,
          password: PASSWORD,
        })
        .then((response) => {
          this.auth = "Bearer " + response.data.access;
          axios
            .get(RUTA_API + "/cas/?search=2,true", {
              headers: { Authorization: this.auth },
            })
            .then((res) => {
              this.itemsClinicas = res.data;
              this.dialogLoad = false;
            })
            .catch((res) => {
              console.warn("Error:", res);
              this.dialog = false;
              this.dialogLoad = false;
            });
        })
        .catch((response) => {
          response === 404
            ? console.warn("lo sientimos no tenemos servicios")
            : console.warn("Error:", response);
        });
    },
    close() {
      this.$emit('closeDialogAsignarCupo');
      this.dialog = false;
      this.editedItem.paciente = "";
      this.editedItem.clinica = "";
      this.editedItem.turno = "";
      this.editedItem.frecuencia = "";
      this.editedItem.tipoPuesto = "";
      this.editedItem.numeroPuesto = "";
    },
    save() {
      this.clinicaFinal();
      if (this.itemsClinicaFinal.length == 0) {
        Swal.fire({
          title: "Error!",
          text: "¡Debe completar todos los campos!",
          icon: "error",
          confirmButtonText: "Aceptar",
        });
        return;
      }
      axios
        .post(RUTA_API + "/api/token/", {
          username: USUARIO,
          password: PASSWORD,
        })
        .then((response) => {
          this.auth = "Bearer " + response.data.access;
          axios
            .post(
              RUTA_API + "/generar_asignacion_cupo/",
              {
                fecha_reg: new Date(Date.now())
                  .toISOString()
                  .substr(0, 10),
                usuario_reg: this.usuario + "|" + this.nombre,
                paciente: this.editedItem.paciente,
                parameCentroPuesto: this.itemsClinicaFinal[0].id_ParametroCentro,
                estado: true
              },
              {
                headers: { Authorization: this.auth },
              }
            )
            .then((res) => {
              Swal.fire({
                title: "¡Exito!",
                text: "¡Se registró con exito!",
                icon: "success",
                confirmButtonText: "Aceptar",
              });
              this.close();
            })
            .catch((res) => {
              console.log("Error1:", res);
              this.dialogDataApi = false;
              Swal.fire({
                title: "Error!",
                text: "¡La clínica no se pudo registrar!",
                icon: "error",
                confirmButtonText: "Aceptar",
              });
            });
        })
        .catch((response) => {
          response === 404
            ? console.warn("lo sientimos no tenemos servicios")
            : console.warn("Error:", response);
        });
    },
  },
  mounted() {
    if (!sessionStorage.getItem("keyValue")) {
      this.$router.push("/");
    }
  },
  created() {
    this.perfil = sessionStorage.getItem("perfil");
    this.url = sessionStorage.getItem("url");
    this.usuario = sessionStorage.getItem("usuario");
    this.urlCas = sessionStorage.getItem("urlCas");
    this.editedItem.paciente = this.pacienteData ? this.pacienteData.url.split("/")[4] : null;
    console.log("pacienteData", this.pacienteData);
    //INICIO DE CONSULTA
    this.listarPacientes();
    this.clinicasInit();
  },
  components: {
    ListaClinicaCupos
  },
};
</script>
